export const getFilename = (
  filename?: string | null,
  mimeType?: string | null
) => {
  // if filename is empty, make filename a '1'
  if (!filename) {
    filename = '1';
  }

  // check for null or undefined mimeType
  if (!mimeType) {
    mimeType = '';
  }

  // check if filename has an extension
  const hasExtension = /\.[0-9a-z]+$/i.test(filename);

  // if it has an extension, return as is
  if (hasExtension) {
    return filename;
  }

  // if no extension, try to determine from mimeType
  const extensionMap: { [key: string]: string } = {
    'application/pdf': '.pdf',
    'image/jpeg': '.jpg',
    'image/png': '.png',
    'text/plain': '.txt',
  };

  const extension = extensionMap[mimeType] || '';
  return filename + extension;
};
